import moment from 'moment'
import {
  CAMPAIGN_STATUS_LABELS, CAMPAIGN_STATUS_LABELS_RESULTS, CHANNEL_OPTIONS, CHANNEL_LABELS, SCOPE_OPTIONS, CHANNEL_PRODUCT_KINDS, REPORTING_GROUPS_KINDS
} from '@/utils/campaignOptions'
import { USER_ROLES_LABELS } from '@/api/authService'
import i18n from '@/i18n'

const statusOptions = Object.keys(CAMPAIGN_STATUS_LABELS).map(key => ({
  value: key,
  label: CAMPAIGN_STATUS_LABELS[key]
}))
const statusResultsOptions = Object.keys(CAMPAIGN_STATUS_LABELS_RESULTS).map(key => ({
  value: key,
  label: CAMPAIGN_STATUS_LABELS_RESULTS[key]
}))
const channelOptions = Object.keys({ ...CHANNEL_OPTIONS }).map(key => ({
  value: key,
  label: CHANNEL_LABELS[key]
}))
const reportingGroupsOptions = Object.keys({ ...REPORTING_GROUPS_KINDS }).map(key => ({
  value: key,
  label: REPORTING_GROUPS_KINDS[key]
}))

export const defaultFilters = () => [
  {
    title: i18n.t('SELECT_CENTER'),
    title_search: i18n.t('SEARCH_CENTER'),
    display: 'auto-complete',
    key: 'shop_id',
    multiple: true,
    remote: {
      url: '/shops',
      method: 'GET'
    },
    value: []
  },
  {
    title: i18n.t('SELECT_ADVERT'),
    title_search: i18n.t('SEARCH_ADVERTS'),
    display: 'auto-complete',
    key: 'advert_id',
    multiple: true,
    remote: {
      url: '/adverts',
      method: 'GET'
    },
    value: []
  },
  {
    title: i18n.t('SELECT_EXCLUSIVIST'),
    title_search: i18n.t('SEARCH_EXCLUSIVIST'),
    display: 'auto-complete',
    key: 'advert_exclusivist',
    multiple: true,
    remote: {
      url: '/exclusivists',
      method: 'GET'
    },
    value: []
  },
  {
    title: i18n.t('ADVERT_STATUSES'),
    display: 'toggle-group',
    multiple: false,
    key: 'advert_is_active',
    options: [
      { label: i18n.t('ACTIVE_ADVERT'), value: 'true' },
      { label: i18n.t('INACTIVE_ADVERT'), value: 'false' }
    ],
    value: null
  },
  {
    title: i18n.t('INCIDENCE'),
    display: 'toggle-group',
    multiple: false,
    key: 'advert_has_incidences',
    options: [
      { label: i18n.t('WITH_INCIDENCES'), value: 'true' },
      { label: i18n.t('WITHOUT_INCIDENCES'), value: 'false' }
    ],
    value: null
  },
  {
    title: i18n.t('ADVERT_TYPE'),
    display: 'button-group',
    multiple: true,
    key: 'advert_type',
    options: [
      { label: i18n.t('ADVERT_TYPE_MONO'), value: 'mono' },
      { label: i18n.t('ADVERT_TYPE_OTHER'), value: 'otros' },
      { label: i18n.t('ADVERT_TYPE_WALL'), value: 'valla' },
      { label: i18n.t('ADVERT_TYPE_DIGITAL'), value: 'digital' }
    ],
    value: []
  },
  {
    title: i18n.t('FULLTEXT_SEARCH'),
    display: 'fulltext',
    multiple: false,
    external: true,
    key: 'fulltext',
    options: [],
    value: null
  },
  {
    title: i18n.t('SELECT_CAMPAIGN'),
    title_search: i18n.t('SEARCH_CAMPAIGN'),
    display: 'auto-complete',
    key: 'campaign_id',
    multiple: true,
    remote: {
      url: '/campaigns',
      extras: '&status=ACTIVE,FINISHED',
      method: 'GET',
      /** Filter Object composition
       * the key is the backend param for the url
       * the value is the filter state key to read the value from
       */
      filters: {
        shops__in: 'shop_id',
        finish_date__gte: 'start_date',
        start_date__lte: 'finish_date'
      }
    },
    value: []
  },
  {
    title: i18n.t('SELECT_PRODUCT'),
    title_search: i18n.t('SEARCH_PRODUCT'),
    display: 'auto-complete-product',
    key: 'product_id',
    multiple: true,
    remote: {
      url: '/campaigns/products',
      method: 'GET',
      filters: {
        shop_related__in: 'shop_id'
      }
    },
    value: []
  },
  {
    title: i18n.t('CAMPAIGN_STATUS'),
    display: 'toggle-group',
    multiple: false,
    key: 'campaign_status',
    options: statusOptions,
    value: null
  },
  {
    title: i18n.t('CAMPAIGN_STATUS'),
    display: 'toggle-group',
    multiple: false,
    key: 'campaign_status_results',
    options: statusResultsOptions,
    value: null
  },
  {
    title: i18n.t('CAMPAIGN_TYPE'),
    display: 'toggle-group',
    multiple: false,
    key: 'direction',
    options: CHANNEL_PRODUCT_KINDS,
    value: null
  },
  {
    title: i18n.t('CAMPAIGN_SCOPE'),
    display: 'toggle-group',
    multiple: false,
    key: 'campaign_scope',
    options: SCOPE_OPTIONS,
    value: null
  },
  {
    title: i18n.t('CHANNEL'),
    display: 'button-group',
    multiple: true,
    key: 'campaign_channel',
    options: channelOptions,
    value: []
  },
  {
    title: i18n.t('CHANNEL'),
    display: 'toggle-group',
    multiple: false,
    key: 'campaign_channel_summary',
    options: channelOptions,
    value: null
  },
  {
    title: i18n.t('START_DATE'),
    display: 'date-picker',
    multiple: false,
    external: true,
    key: 'start_date',
    options: [],
    value: moment().subtract(3, 'month').toDate()
  },
  {
    title: i18n.t('END_DATE'),
    display: 'date-picker',
    multiple: false,
    external: true,
    key: 'finish_date',
    options: [],
    value: moment().add(1, 'month').toDate()
  },
  {
    title: i18n.t('ROLE'),
    display: 'toggle-group',
    multiple: false,
    key: 'user_role',
    options: Object.entries(USER_ROLES_LABELS).map(([key, value]) => ({ value: key, label: value })),
    value: null
  },
  {
    title: i18n.t('START_DATE'),
    display: 'date-picker',
    multiple: false,
    external: true,
    key: 'start_date_global',
    options: [],
    value: moment().subtract(3, 'month').toDate()
  },
  {
    title: i18n.t('END_DATE'),
    display: 'date-picker',
    multiple: false,
    external: true,
    key: 'finish_date_global',
    options: [],
    value: moment().add(1, 'month').toDate()
  },
  {
    title: i18n.t('REPORTING_GROUP'),
    display: 'button-group',
    multiple: true,
    key: 'terr_unit',
    options: reportingGroupsOptions,
    value: []
  }
]
